import { render, staticRenderFns } from "./BoardsDetail.vue?vue&type=template&id=6deb1aee"
import script from "./BoardsDetail.vue?vue&type=script&lang=js"
export * from "./BoardsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6deb1aee')) {
      api.createRecord('6deb1aee', component.options)
    } else {
      api.reload('6deb1aee', component.options)
    }
    module.hot.accept("./BoardsDetail.vue?vue&type=template&id=6deb1aee", function () {
      api.rerender('6deb1aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/BoardsDetail.vue"
export default component.exports